const login = {
    init(){

    },
    modalAfterReg: {
        insertModal(){
            const modalSpawn = document.querySelector('#modal-after-reg');
            if(modalSpawn){
                modalSpawn.innerHTML = `
                <div data-modal-message-close class="modal-message-wrapper d-flex align-items-center justify-content-center">
                    <div data-modal-container class="modal-message-container d-flex flex-column justify-content-between">
                    <div class="d-flex flex-column">
                        <div class="fs-30 lh-120p c-neutral-100 mb-31 text-center">Activate account</div>
                        <div class="fs-22 lh-130p c-neutral-100 text-center">Please check your email to activate your account and sign in</div>
                    </div>
                    <button data-modal-message-close class="modal-message-btn">Got it</button>
                    </div>
                    <div class="modal-backdrop fade show"></div>
                </div>
                `
                modalSpawn.querySelector('[data-modal-container]').addEventListener('click', this.handlerStopPropagation)
                modalSpawn.querySelectorAll('[data-modal-message-close]').forEach(close => {
                    close.addEventListener('click', (e)=>{e.stopPropagation(); this.handlerClose(modalSpawn)})
                })
            }
        },
        handlerStopPropagation(e){
            e.stopPropagation()
        },
        handlerClose(modalSpawn){
            modalSpawn.querySelector('[data-modal-container]').removeEventListener('click', this.handlerStopPropagation)
            modalSpawn.querySelectorAll('[data-modal-message-close]').forEach(close => {
                close.removeEventListener('click', this.handlerClose)
            })
            modalSpawn.innerHTML = '';
        }
    }
}